export default defineNuxtRouteMiddleware(async (to) => {
    const reward = useReward()
    const targetPages = ['/cart', '/', '/order-summary', '/collections/gift-cards/cart', '/collections/gift-cards/order-summary', '/collections/giftcards']
    try {
        if (targetPages.includes(to.path)) {
            await reward.initialize()
          }
    } catch (err) {
      console.error('Error during authentication:', err);
    }
  });

